import React from "react";
import { Link } from "react-router-dom";
import dataGrades from "../../config/grades";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";

export default function GradeNav() {
  const renderGrades = () => {
    return dataGrades.map((grade, index) => {
      if (index === 0) {
        return (
          <Link
            key={grade.url}
            to={`${routeCodes.GRADES}${grade.url}`}
            className="gradenav-link"
            data-testid="grade-link"
          >
            {getString("grades.pre")}
            <span className="gradenav-link-post">{getString("grades.levels.0")}</span>
          </Link>
        );
      }
      return (
        <Link
          key={grade.url}
          to={`${routeCodes.GRADES}${grade.url}`}
          className="gradenav-link"
          data-testid="grade-link"
        >
          {getString("grade.1")}
          <span className="gradenav-link-post">{getString(`grades.levels.${index - 1}`)}</span>
        </Link>
      );
    });
  };

  return (
    <div className="wrapper gradenav">
      <div className="container gradenav-container">{renderGrades()}</div>
    </div>
  );
}
